export const assistantTierKeys = {
  root: ['assistant-tiers'] as const,
  config: (entityId: string) => ['assistant-tiers', entityId] as const,
}

export const assistantAvailabilityKeys = {
  root: ['assistant-availability'] as const,
  entity: (entityId: string) => ['assistant-availability', entityId] as const,
}
